import { redirect } from 'react-router-dom';
import Cookies from '../../lib/cookies';
import UserService from '../../services/User.service';

// Load user information (WIP). If no access token is available, redirect to login
const authLoader = async () => {
	const token = Cookies.getAccessToken();
	if (!token || !token.user) {
		Cookies.clear();
		throw redirect('/login');
	}
	const usuario = await UserService.get(token.user.id);
	if (!usuario) throw redirect('/login');

	const payload = Cookies.getAccessTokenPayload();
	const user = payload
		? {
			...usuario,
			name: payload.name || usuario.name,
			email: payload.username || usuario.email,
			permissions: {
				...usuario.permissions,
				...payload.permissions,
			},
			type: payload.type || usuario.type,
			client: payload.client
				? {
					...usuario.client,
					id: payload.client.id,
					fantasyName: payload.client.fantasy_name,
					cnpj: payload.client.cnpj,
					system_configs: payload.client.system_configs,
				}
				: usuario.client,
		}
		: usuario;
	const idCliente = user.client?.id;
	if (idCliente) Cookies.setAccount(idCliente);
	else Cookies.removeAccount();
	const accountId = idCliente ? String(idCliente) : '';
	return { user, accountId };
};

export default authLoader;
